import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';

import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';

@Component({
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    MatFormFieldModule,
    MatSelectModule,
  ],
  selector: 'app-date-time-selector',
  templateUrl: './date-time-selector.component.html',
  styleUrls: ['./date-time-selector.component.scss'],
})
export class DateTimeSelectorComponent implements OnInit {
  @Input() mode?: 'hour-minute' | 'month-day';
  @Input() value?: string;
  @Output() valueChanged = new EventEmitter<string>();

  @Input() uiFramework: 'ionic' | 'material' = 'ionic';

  hoursMinutes?: { hour: string; minute: string };
  monthDay?: { month: string; day: string };

  ngOnInit() {
    if (!this.mode || !this.value) {
      return;
    }

    if (this.mode === 'hour-minute') {
      const [hour, minute] = this.value.split(',').map((num) => ('0' + num.trim()).slice(-2));
      this.hoursMinutes = { hour, minute };
    } else if (this.mode === 'month-day') {
      const [month, day] = this.value.split(',').map((num) => ('0' + num.trim()).slice(-2));
      this.monthDay = { month, day };
    }
  }

  onValueChange(key: string, value: number) {
    const paddedValue = ('0' + value).slice(-2);
    if (this.mode === 'hour-minute' && this.hoursMinutes && (key === 'hour' || key === 'minute')) {
      this.hoursMinutes[key] = paddedValue;
      this.valueChanged.emit(`${Number(this.hoursMinutes.hour)},${Number(this.hoursMinutes.minute)}`);
    } else if (this.mode === 'month-day' && this.monthDay && (key === 'month' || key === 'day')) {
      this.monthDay[key] = paddedValue;
      this.valueChanged.emit(`${Number(this.monthDay.month)},${Number(this.monthDay.day)}`);
    }
  }

  createRange(n: number): number[] {
    return Array.from({ length: n }, (_, i) => i);
  }
}
